import { render, staticRenderFns } from "./related_items.vue?vue&type=template&id=80808afe&scoped=true&"
import script from "./related_items.vue?vue&type=script&lang=js&"
export * from "./related_items.vue?vue&type=script&lang=js&"
import style0 from "./related_items.vue?vue&type=style&index=0&id=80808afe&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "80808afe",
  null
  
)

export default component.exports